import {CLEAR_DISPLAYED_FIXTURE, getOneFixtureAsync} from "../actions";
import {createReducer} from "typesafe-actions";
import {FixtureElement} from "../../../models/api/codegen/code";

type tmp = FixtureElement;

export const displayedFixture = createReducer({} as FixtureElement)
    .handleAction(getOneFixtureAsync.success, (state: tmp, action: { payload: FixtureElement }): FixtureElement => action.payload)
    .handleAction(CLEAR_DISPLAYED_FIXTURE, (state: tmp, action) => action.payload);
